import { postApiRttData } from "@/util/APIUtils";
import { getTokenKey } from "@/util/auth";

export function postApiRtt(path, token, rtt) {
  const data = {
    sName: path,
    sToken: token,
    rtt: rtt
  };
  postApiRttData(data).then();
}

export function perfDataCalc() {
  // 计算从导航到所有资源加载完毕的时间
  try {
    const nt = window.performance.getEntriesByType('navigation')[0];
    const time = nt.loadEventEnd - nt.startTime;
    postApiRtt('/resource/load', getTokenKey(), time);
  } catch {
    return;
  }
}